import { envVariables } from '@/utils/env';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

export const initDataDogRum = () => {
  const {
    datadogRumEnable,
    datadogRumApplicationId,
    datadogRumClientToken,
    datadogRumSite,
    datadogRumService,
    datadogRumEnv,
  } = envVariables();
  if (!datadogRumEnable) return;
  datadogRum.init({
    applicationId: datadogRumApplicationId!,
    clientToken: datadogRumClientToken!,
    site: datadogRumSite!,
    service: datadogRumService!,
    env: datadogRumEnv!,

    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    defaultPrivacyLevel: 'mask-user-input',
    plugins: [reactPlugin({ router: false })],
  });
};
